webpackJsonp([52200463085310],{

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HulpiaArchitectenComp = function HulpiaArchitectenComp() {
	        return _react2.default.createElement(
	                _styles.HulpiaArchitecten,
	                null,
	                _react2.default.createElement(
	                        _styles.HulpiaTitle,
	                        null,
	                        'HULPIA'
	                ),
	                _react2.default.createElement(
	                        _styles.HulpiaSubTitle,
	                        null,
	                        'architecten'
	                )
	        );
	};
	
	exports.default = HulpiaArchitectenComp;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n'], ['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styles = __webpack_require__(13);
	
	var _Navigation = __webpack_require__(21);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _HulpiaArchitectenComp = __webpack_require__(73);
	
	var _HulpiaArchitectenComp2 = _interopRequireDefault(_HulpiaArchitectenComp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Sticky = _styledComponents2.default.div(_templateObject);
	
	var TeamPage = function (_Component) {
	  _inherits(TeamPage, _Component);
	
	  function TeamPage() {
	    _classCallCheck(this, TeamPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TeamPage.prototype.render = function render() {
	    var teamItems = this.props.data.allTeamJson.edges[0].node.team;
	    var teamImage = this.props.data.allTeamJson.edges[0].node.teamImage;
	    var navItems = this.props.data.allNavigationJson.edges;
	    var subNavContact = navItems.filter(function (_ref, index) {
	      var navItem = _ref.node;
	      return index === 1;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        Sticky,
	        null,
	        _react2.default.createElement(_Navigation2.default, { items: subNavContact, navType: 'sub' })
	      ),
	      _react2.default.createElement(
	        _styles.SplitSection,
	        null,
	        _react2.default.createElement(
	          _styles.LeftSection,
	          null,
	          _react2.default.createElement(_HulpiaArchitectenComp2.default, null),
	          _react2.default.createElement(_styles.TeamImage, { src: teamImage, alt: '' })
	        ),
	        _react2.default.createElement(
	          _styles.RightSection,
	          null,
	          teamItems.map(function (_ref2, index) {
	            var naam = _ref2.naam,
	                functie = _ref2.functie,
	                telefoon = _ref2.telefoon,
	                email = _ref2.email;
	
	            return _react2.default.createElement(
	              _styles.TeamList,
	              { key: index },
	              _react2.default.createElement(
	                _styles.TeamListItem,
	                null,
	                naam,
	                ' \u2014 ',
	                functie
	              ),
	              _react2.default.createElement(
	                _styles.TeamListItemGrey,
	                null,
	                _react2.default.createElement(
	                  _styles.Phone,
	                  { href: 'tel:' + telefoon },
	                  telefoon
	                )
	              ),
	              _react2.default.createElement(
	                _styles.TeamListItemGrey,
	                null,
	                _react2.default.createElement(
	                  _styles.Email,
	                  { href: 'mailto:' + email },
	                  email
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return TeamPage;
	}(_react.Component);
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = TeamPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-team-js-aa87598d8480d2804eb9.js